// Part done's outsides and insides on the phone (docs/plans/job-bits/PLAN.md 2; drawings
// https://claude.ai/artifact/TqAvW6RB2USfibzWKRNWyw): the words and today's charge the Job done sheet shows before Save.
// The server's functions/lib/part-done.ts planPart decides what is saved; this is its copy for the screen, and
// scripts/part-plan.test.mjs keeps the two giving the same answers (Sonnet: one rule in two places drifts by a penny).

export type OutsidePart = 'all' | 'fronts' | 'backs' | 'downstairs' | 'upstairs' | 'none'
export type InsidePart = 'all' | 'downstairs' | 'upstairs' | 'none'

const OUTSIDE_LEFT: Record<OutsidePart, OutsidePart> = { all: 'none', none: 'all', fronts: 'backs', backs: 'fronts', downstairs: 'upstairs', upstairs: 'downstairs' }
const INSIDE_LEFT: Record<InsidePart, InsidePart> = { all: 'none', none: 'all', downstairs: 'upstairs', upstairs: 'downstairs' }

export function partWords(outside: OutsidePart, inside: InsidePart, hasInsides: boolean): string {
  if (!hasInsides) return outside
  const out = outside === 'all' ? ['outsides'] : outside === 'none' ? [] : [outside]
  const inn = inside === 'all' ? ['insides'] : inside === 'none' ? [] : [`insides ${inside}`]
  return [...out, ...inn].join(', ')
}

export interface PartView { part: string; restPart: string; today: number | null; rest: number | null; whole: boolean; nothing: boolean }

// Today's charge (each half done is half its price, the odd penny left for the rest) and what is left. `whole`: all of it
// was done (that is the whole job); `nothing`: none of it was.
export function partView(wholePrice: number | null, inside: number | null, outside: OutsidePart, insidePart: InsidePart): PartView {
  const ins = inside !== null && inside > 0 ? inside : 0
  const inn: InsidePart = ins ? insidePart : 'none'
  const half = (x: string): number => (x === 'all' ? 2 : x === 'none' ? 0 : 1)
  const share = (price: number, x: string): number => (half(x) === 2 ? price : half(x) === 0 ? 0 : Math.floor(price / 2))
  const today = wholePrice === null ? null : share(wholePrice - ins, outside) + share(ins, inn)
  return {
    part: partWords(outside, inn, ins > 0),
    restPart: partWords(OUTSIDE_LEFT[outside], INSIDE_LEFT[inn], ins > 0),
    today,
    rest: wholePrice === null || today === null ? null : wholePrice - today,
    whole: half(outside) === 2 && (!ins || half(inn) === 2),
    nothing: half(outside) === 0 && (!ins || half(inn) === 0),
  }
}

export function partLabel(part: string): string {
  return part.charAt(0).toUpperCase() + part.slice(1)
}
